/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type DesignProfileStatus = "ACTIVE" | "DELETED" | "NEW" | "PENDING" | "%future added value";
export type TradeFirmSalesTier = "P_AND_M" | "TIER_1" | "TIER_2" | "TIER_3" | "TIER_4" | "UNKNOWN" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type userTracking_user = {
    readonly createdDate: string | null;
    readonly firstSessionDate: string | null;
    readonly isTrade: boolean | null;
    readonly hasVipPermission: boolean | null;
    readonly authMetadata: {
        readonly emailOnly: boolean | null;
        readonly hasPassword: boolean | null;
    } | null;
    readonly profile: {
        readonly email: string | null;
        readonly zipCode: string | null;
        readonly currency: Currency | null;
    } | null;
    readonly serviceId: string | null;
    readonly totalMessagesToDealers: number | null;
    readonly tradeFirm: {
        readonly serviceId: string | null;
        readonly tier: TradeFirmSalesTier | null;
        readonly profileStatus: DesignProfileStatus | null;
        readonly rewards: {
            readonly currentProgram: {
                readonly programInfo: {
                    readonly code: string | null;
                } | null;
            } | null;
        } | null;
    } | null;
    readonly verifiedTradeStatus: string | null;
    readonly mentionMeTagParameters: {
        readonly ciphertext: string | null;
        readonly nonce: string | null;
    } | null;
    readonly " $refType": "userTracking_user";
};
export type userTracking_user$data = userTracking_user;
export type userTracking_user$key = {
    readonly " $data"?: userTracking_user$data;
    readonly " $fragmentRefs": FragmentRefs<"userTracking_user">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "userTracking_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "createdDate",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "firstSessionDate",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": "isTrade",
      "name": "hasPermission",
      "args": [
        {
          "kind": "Literal",
          "name": "name",
          "value": "B_VERIFIED_TRADE"
        }
      ],
      "storageKey": "hasPermission(name:\"B_VERIFIED_TRADE\")"
    },
    {
      "kind": "ScalarField",
      "alias": "hasVipPermission",
      "name": "hasPermission",
      "args": [
        {
          "kind": "Literal",
          "name": "name",
          "value": "B_VIP_CHECKOUT"
        }
      ],
      "storageKey": "hasPermission(name:\"B_VIP_CHECKOUT\")"
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "authMetadata",
      "storageKey": null,
      "args": null,
      "concreteType": "UserExistsMetadataType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "emailOnly",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "hasPassword",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "profile",
      "storageKey": null,
      "args": null,
      "concreteType": "Profile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "email",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "zipCode",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "currency",
          "args": null,
          "storageKey": null
        }
      ]
    },
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "totalMessagesToDealers",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "tradeFirm",
      "storageKey": null,
      "args": null,
      "concreteType": "TradeFirmType",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "tier",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "profileStatus",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "rewards",
          "storageKey": null,
          "args": null,
          "concreteType": "TradeFirmRewards",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "currentProgram",
              "storageKey": null,
              "args": null,
              "concreteType": "ParentProgram",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "programInfo",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "LoyaltyProgram",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "code",
                      "args": null,
                      "storageKey": null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "verifiedTradeStatus",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "mentionMeTagParameters",
      "storageKey": null,
      "args": null,
      "concreteType": "mentionMeTagParameters",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "ciphertext",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "nonce",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
})();
(node as any).hash = '0413573547c09301c20c058ae754bfa9';
export default node;
